module.exports = __webpack_public_path__ + "img/logo.209ef576.png";